import * as axios from "axios";
import {clearCartRequiredField} from "../common/Helpers/storageHelper";


const LOCALHOST_API_URL = process.env.REACT_APP_API_LOCALHOST_URL;
const WORK_API_URL = process.env.REACT_APP_API_WORK_URL;
const TEST2023_API_URL = process.env.REACT_APP_API_TEST2023_URL;

const errorHandlerInstance = axios.create({
    //withCredentials: true,
    baseURL: LOCALHOST_API_URL,
    headers:{

    }
});

const instance = axios.create({
    //withCredentials: true,
    //baseURL: LOCALHOST_API_URL,
    //baseURL: TEST2023_API_URL,
    baseURL: WORK_API_URL,

    headers:     {
        'Authorization':  '',
        'My-Custom-Header': 'foobar',
        "Content-Type": "application/json; charset=utf8"
    }
});

const authInterceptor = config => {
    let tokenFromSessionStorage = JSON.parse(sessionStorage.getItem('token'));
    let tokenFromLocalStorage = JSON.parse(localStorage.getItem('token'));
    const token = tokenFromSessionStorage ? tokenFromSessionStorage : tokenFromLocalStorage
    
    if(token){
        config.headers.Authorization = `${token}`
    }
    else{
        config.headers.Authorization = '';
    }
    return config
}
instance.interceptors.request.use(authInterceptor)
instance.interceptors.response.use(response => {
    return response;
}, error => {
    console.log(error)
    if (!error.response) {
        // Обработка ошибки, когда сервер упал с необработанной ошибкой
        console.log("Сервер упал с необработанной ошибкой");
        const result = {
            data:  JSON.stringify( {
                isSucccess: false,
                data: null,
                message: 'Сервер не відповідає, зверніться до менеджера або спробуйте пізніше.'
            }
            )
        }
        return result;
    } 
    else if (error.response.status === 401) {
        debugger
        //const navigate = useNavigate();
        sessionStorage.setItem('redirectUrl', window.location.pathname);
        sessionStorage.removeItem('token')
        localStorage.removeItem('token')
        clearCartRequiredField();
        window.location = "/login";
    }
    else if (error.response.status === 451) {
        console.log("Доступ обмежений через юридичні причини (451)");
        const result = {
            data: JSON.stringify({
                isSucccess: false,
                data: null,
                message: 'Доступ обмежений через юридичні причини (451). Зверніться до менеджера.',
                httpStatusCode: 451
            })
        };
        return result;
    }
    return error;
});

export const authAPI = {
    me() {
        return instance.get(`auth/me`);
    },
    login(login, password, acceptPolicyFlag = false, rememberMe = false, captcha = null) {
        return instance.post(`auth/login`, { login, password, isAcceptedWithPolicy: acceptPolicyFlag });
    },
    logout() {
        return instance.delete(`auth/login`);
    },
    getClientInfo() {
        return instance.get(`auth`);
    },
    // getClientsProducts(id) {
    //     return instance.get(`products/`+ id);
    // },
    getAvailableAccountCredentials(){
        return instance.post(`auth/GetOtherAccounts`)
    },
    changeAccountCredentials(id){
        return instance.post(`auth/ChangeAccount`, JSON.stringify(id))
    }
}

export const accountAPI = {
    getClientInfo(id) {
        return instance.get(`auth/`+ id);
    }
}

export const cartAPI = {
    setCart(cart){
        return instance.post('cart/', {cart})
    },

    actualizeCart(){
        return instance.post('cart/actualizeCart')
    },

    getCart(){
        return instance.get('cart/')
    }
}

export const productsAPI = {
    getProductFirstImage(id){
        return instance.post(`product/getProductFirstImage/`, JSON.stringify(id));
    },

    getProductInfo(id){
        return instance.get(`product/`+id);
    },
    getClientsProducts() {
        return instance.get(`product/`);
    }
}

export const productFilterAPI = {
    getProductsWithFilters(body) {
        return instance.post(`product/productwithfilter`, body)
    }
}

export const marketingStockAPI = {
    loadMarketingStockFileById(id) {
        return instance.post(`marketingStock/LoadFile/`, JSON.stringify(id) )
    },
    getMarketingStocks() {
        return instance.post(`marketingStock/GetMarketingStocks`)
    },
    getMarketingStockInfo(id){
        return instance.get(`marketingStock/`+id);
    },
}

export const accountDeliveryAddressAPI = {
    getActive() {
        return instance.post(`accountDeliveryAddress/GetActive`)
    }
}

export const contactAPI = {
    updateContactByModel(model){
        return instance.post('contact/UpdateContactByModel', model)
    }
}

export const salesOrderAPI = {
    create(salesOrder) {
        return instance.post(`salesorder/`, salesOrder)
    },
    getAll() {
        return instance.get(`salesorder/`)
    },
    repeatOrder(salesOrderId){
        return instance.get(`salesorder/`+ salesOrderId)
    },
    cancelOrder(cancelModel)
    {
        return instance.post(`salesorder/cancelSalesOrder`, cancelModel)
    }
}

export const pageInfoAPI = {
    getInfoForCartPage(){
        return instance.post(`pageInfo/getCartPageInfo/`)
    }
}

export const notificationAPI = {
    getAllNotifications(){
        return instance.get(`notification/`)
    },
    getNotificationById(id){
        return instance.get(`notification/` + id)
    }
}

export const lubeMatchAPI = {
    searchCarByVinNumber(inputString){
        return instance.post(`lubematch/GetCarByVinModel/`, JSON.stringify({InputString: inputString.toUpperCase()}))
    },
    getCarRecommendation(autoRef, autoVinOrNumber, autoName){
        return instance.post(`lubematch/GetCarRecommendations/`, {AutoRef:autoRef, AutoVinOrNumber:autoVinOrNumber, AutoName: autoName} )
    },
    getQueryHistoryList() {
        return instance.post(`lubematch/GetQueryHistory/`)
    },
    GetRecommendationByHistoryId(id) {
        return instance.post(`lubematch/GetRecommendationByHistoryId/`, JSON.stringify(id))
    }
}